export type SavedView = {
  key: string;
  label: string;
  count?: number | string;
};

type SavedViewsProps = {
  views: SavedView[];
  active: string;
  onChange: (view: string) => void;
};

export function SavedViews({ views, active, onChange }: SavedViewsProps) {
  return (
    <div className="saved-views" role="tablist" aria-label="저장 보기">
      {views.map((view) => (
        <button
          key={view.key}
          type="button"
          role="tab"
          aria-selected={active === view.key}
          className={active === view.key ? "saved-view is-active" : "saved-view"}
          onClick={() => onChange(view.key)}
        >
          <span>{view.label}</span>
          {view.count !== undefined ? <small>{view.count}</small> : null}
        </button>
      ))}
    </div>
  );
}
